// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zq4zj","index":"styles_index__XmKIa"};